import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-kiosk-overview',
  templateUrl: './kiosk-overview.component.html',
  styleUrls: ['./kiosk-overview.component.css']
})
export class KioskOverviewComponent implements OnInit {

  @Input() kiosk: any;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/kiosk-setup-wizard/kiosk-overview/kiosk-overview.component.ts